import { SignInMethodOption, SignInMethodType, SignInVerification } from '../../../../entities/SignInMethod';
import { ResendFeedback } from '../../../../entities/Login';
import CodeMethodStepModel from '../CodeMethodStep/model';

export default class CodeStepModel {
  static readonly CODE_LENGTH = 6;
  static readonly INVALID_CODE_MESSAGE = 'Código inválido';
  static readonly RESEND_SUCCESS_MESSAGE = 'Código enviado com sucesso';
  static readonly RESEND_ERROR_MESSAGE = 'Erro ao enviar o código';

  static isComplete(code: string): boolean {
    return code.length === CodeStepModel.CODE_LENGTH;
  }

  static getResendMessage(feedback: ResendFeedback | null): string | null {
    if (feedback === ResendFeedback.SUCCESS) return CodeStepModel.RESEND_SUCCESS_MESSAGE;
    if (feedback === ResendFeedback.ERROR) return CodeStepModel.RESEND_ERROR_MESSAGE;
    return null;
  }

  static getAlternativeMethod(verifyData: SignInVerification, current: SignInMethodOption): SignInMethodOption | null {
    return CodeMethodStepModel.listOptions(verifyData).find(option => option.type !== current.type) ?? null;
  }

  static getSwitchMethodLabel(type: SignInMethodType): string {
    const labels = {
      [SignInMethodType.PHONE]: 'Enviar código por WhatsApp',
      [SignInMethodType.EMAIL]: 'Enviar código por e-mail'
    };
    return labels[type];
  }
}
